import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from "@mui/material";
import { useAppSelector,useAppDispatch } from "../stores/hooks";
import { useEffect, useState } from "react";

export default function ConfirmDialog({isopen, title,message,callback,needComments=true,minCommentChar=0,yesButtonText='Yes',cancelButtonText='Cancel'}:{isopen:boolean,title:string,
    message:string,callback:any,needComments:boolean,minCommentChar?:number,yesButtonText?:string,cancelButtonText?:string}) {
    const [open,setOpen]=useState<boolean>(isopen);
    const [remarks,setRemarks]=useState<string|null>(null);
    const [error, setError] = useState<string>('');
    useEffect(()=>{
        setOpen(isopen);
    },[isopen]);
    const handleClose=()=>{
        setError('');
        callback(false,"",title);
    }
    const handleOk=()=>{
        
    if(needComments==true)
    {
        if ( remarks == null || remarks.length < minCommentChar) {
            setError('Remarks must be at least '+ minCommentChar +' characters long.');
           
        }
        else{
            setError('');
            callback(true,remarks,title);
        }
    }
    else
    {
        callback(true,remarks,title);
    }
       
        
    }

    return (
        <Dialog open={open} 
         onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              handleClose(); 
            }   }}
            onSubmit={handleOk}   >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
                <TextField
                    sx={{display:needComments?"block":"none"}}
                    autoFocus
                    margin="dense"
                    id="remarks"
                    label="Remarks"
                    type="text"
                    fullWidth
                    variant="standard"
                    required={needComments}
                    onChange={(event)=>{
                        if (remarks == null || remarks.length < minCommentChar - 1  ) {
                            setError('Remarks must be at least '+ minCommentChar +' characters long.');              
                       }else 
                        {setError('');}
                       setRemarks(event.target.value)
                                         }}
                    error={!!error}
                    helperText={error}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{cancelButtonText}</Button>
                <Button onClick={handleOk}>{yesButtonText}</Button>
            </DialogActions>
        </Dialog>
    )
}